<div class="banner">
    <h1 class="myfav-title an-h-line-height" aria-lable="title">
        {{cmsData?.MyFav}}
    </h1>
    <h3 class="myfav-sub-title an-p-line-height" aria-lable="subtitle">
        {{cmsData?.MyFavSubtitle}}
    </h3>
</div>
